import { ReactNode } from "react";

type BottomConfirmBarProps = {
  label: ReactNode;
  disabled?: boolean;
  disabledHint?: ReactNode;
  onClick: () => void;
  noteAbove?: ReactNode;
  noteBelow?: ReactNode;
  className?: string;
};

export const BottomConfirmBar = ({
  label,
  disabled = false,
  disabledHint,
  onClick,
  noteAbove,
  noteBelow,
  className
}: BottomConfirmBarProps) => {
  return (
    <footer className={`bottom-confirm-bar${className ? ` ${className}` : ""}`}>
      {disabled && disabledHint ? <p className="bottom-confirm-hint">{disabledHint}</p> : null}
      {noteAbove ? <p className="bottom-confirm-note bottom-confirm-note-above">{noteAbove}</p> : null}
      <button type="button" className="primary-button" disabled={disabled} onClick={onClick}>
        {label}
      </button>
      {noteBelow ? <p className="bottom-confirm-note">{noteBelow}</p> : null}
    </footer>
  );
};
